import { createQueryKeys } from '@lukemorales/query-key-factory'

export const favorites = createQueryKeys('favorites', {
  list: null,
  isFavorited: (complexId: string) => [complexId],
})
